import { render, staticRenderFns } from "./VQBForm.vue?vue&type=template&id=3b35c330"
import script from "./VQBForm.vue?vue&type=script&lang=js"
export * from "./VQBForm.vue?vue&type=script&lang=js"
import style0 from "./VQBForm.vue?vue&type=style&index=0&id=3b35c330&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports